var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8522 11.8447L11.8522 11.728C11.8522 11.329 11.5528 11.0073 11.1986 11.0073L2.01624 11.0073L2.01624 9.64721L8.09573 9.64721C8.45306 9.64721 8.74953 9.32929 8.74953 8.92647L8.74953 8.80973C8.74953 8.4069 8.45306 8.08899 8.09573 8.08899L2.01624 8.08899L2.01624 2.67065C2.01624 1.77645 0.799949 1.77645 0.799949 2.67065L0.799949 21.3201C0.799949 21.6953 1.07232 22 1.40808 22L1.69567 22L20.3919 22C20.7275 22 21 21.6955 21 21.3201C21 20.9448 20.7276 20.6402 20.3919 20.6402L2.01598 20.6402L2.01598 18.4013L16.824 18.4013C17.1814 18.4013 17.4778 18.0834 17.4778 17.6806L17.4778 17.5639C17.4778 17.161 17.1814 16.8431 16.824 16.8431L2.01598 16.8431L2.01598 15.4831L14.632 15.4831C14.9893 15.4831 15.2858 15.1652 15.2858 14.7623L15.2858 14.6456C15.2858 14.2428 14.9893 13.9249 14.632 13.9249L2.01598 13.9249L2.01598 12.565L11.207 12.565C11.5577 12.5601 11.8522 12.2397 11.8522 11.8447Z",
    fill: "#111111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.923ebe42.svg";
export { ForwardRef as ReactComponent };